import React, { FC } from 'react';
import cls from 'classnames';

import LogIn from 'src/prize/scenes/LogIn';
import { INavItem } from 'src/prize/types/shoppe';

import { Link } from './atoms/Link';
import { Menu } from './molecules/Menu';

import styles from './index.module.sass';

interface ILinksProps {
  data?: INavItem;
  overlay: boolean;
}

export const Links: FC<ILinksProps> = ({ data, overlay }) => (
  <ul className={cls( styles.container, { [styles.overlay]: overlay })}>
    <li className={styles.login}>
      <LogIn className={cls( styles.authentication, { [styles.visible]: overlay })} isMobile />
    </li>

    {data?.children?.map(( link ) => (
      <li className={styles.item} key={link.url}>
        {link.children.length > 0 ? (
          <Menu
            className={{
              dropdown: styles.dropdown,
              link: cls( styles.link, { [styles.visible]: overlay }),
            }}
            data={link}
          />
        ) : (
          <Link className={cls( styles.link, { [styles.visible]: overlay })} href={link.url}>
            {link.title}
          </Link>
        )}
      </li>
    ))}
  </ul>
);
